import { settingsRoutes } from './settings.routing'
import { SettingsComponent } from './settings.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { GeneralSettingsComponent } from './general-settings/general-settings.component'
import { GisSettingsComponent } from './gis-settings/gis-settings.component'
import { SecuritySettingsComponent } from './security-settings/security-settings.component'
import { FilesystemSettingsComponent } from './filesystem-settings/filesystem-settings.component'
import { EmailSettingsComponent } from './email-settings/email-settings.component'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    SettingsComponent,
    GeneralSettingsComponent,
    GisSettingsComponent,
    SecuritySettingsComponent,
    FilesystemSettingsComponent,
    EmailSettingsComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(settingsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [SettingsComponent],
})
export class SettingsModule {}
